<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>

            Chess Competition Prize Distrubution 2025
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center">
      <h2><span>Chess Competition Prize Distrubution 2025</span></h2>
      <p class="text-center">Winners of the Chess Competition were awarded for their sharp moves and sharper minds. A
        proud moment powered by strategy, focus, and the spirit of Raisoni Foundation.</p>
    </div>
        <!-- <div class="text-end">
      <a href="https://drive.google.com/drive/folders/1WMGkFg2pLJah6YMOda3hYGhk4GKPPzfg" target="_blank" class="cmn-button"> View More</a>
    </div> -->
    <div class="lightBox--gallery">
      <ul class="list-unstyled lightgallery row row-cols-1 justify-content-center row-cols-md-3">

        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-1.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-1.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-1.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid">
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-2.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-2.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-2.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid">
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-3.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-3.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-3.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid">
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-4.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-4.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-4.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid">
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-5.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-5.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-5.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid">
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
            </div>
          </a>
        </li>
      </ul>
    </div>

  </div>
</section>
